import PanelPeriodControl, { type PeriodLabel } from "connected-components/dashboard/components/panel-period-control"
import type { IsoDate } from "helpers/types/dates"
import { useFactorsViewData } from "../hooks/use-factors-view-data"

interface FactorsViewPanelPeriodControlProps {
  isPerformance?: boolean
  driftDates?: { startDate: IsoDate, endDate: IsoDate }
  label?: PeriodLabel
}

export default function FactorsViewPanelPeriodControl({ isPerformance = true, driftDates, label }: FactorsViewPanelPeriodControlProps) {
  const { dateOverride, setDateOverride, clearDateOverride, earliestDate, latestDate, startDate, endDate, isDateOverrideActive } = useFactorsViewData()

  return (
    <PanelPeriodControl
      dates={{ earliestDate, latestDate, startDate, endDate }}
      dateOverride={dateOverride}
      isDateOverrideActive={isDateOverrideActive}
      setDateOverride={setDateOverride}
      clearDateOverride={clearDateOverride}
      isPerformance={isPerformance}
      driftDates={driftDates}
      label={label}
    />
  )
}
